import React from 'react';

import MenuItem from '@material-ui/core/MenuItem';
import Select from '@material-ui/core/Select';
import FormControl from '@material-ui/core/FormControl';
import Checkbox from '@material-ui/core/Checkbox';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';

import { StatusDropdownContext } from './table';
import { Modal } from '@material-ui/core';

function StatusDropdown({ params }) {
  const tableProps = React.useContext(StatusDropdownContext);

  const adminStatus = params.data.adminStatus;

  const [openModal, setOpenModal] = React.useState(false);
  const [clickedStatus, setClickedStatus] = React.useState('');
  const [selectedReasons, setSelectedReasons] = React.useState([]);
  const [isOtherReasonsSelected, setIsOtherReasonsSelected] =
    React.useState(false);
  const [otherReasonText, setOtherReasonText] = React.useState('');
  const [showErrorMessage, setShowErrorMessage] = React.useState(false);

  const getFormattedSelectedReasons = () => {
    if (
      clickedStatus === 'on_hold' &&
      selectedReasons.length === 0 &&
      (!isOtherReasonsSelected ||
        (isOtherReasonsSelected && otherReasonText.length === 0))
    ) {
      setShowErrorMessage(true);
      return;
    }

    const tempArray = selectedReasons.slice();

    if (isOtherReasonsSelected) {
      tempArray.push(otherReasonText);
    }

    return tempArray;
  };

  const handleReasonsMenuClick = (option) => {
    setSelectedReasons((reasonArray) => {
      const index = reasonArray.indexOf(option);
      const tempArray = reasonArray.slice();
      if (index > -1) {
        tempArray.splice(index, 1);
      } else {
        tempArray.push(option);
      }
      return tempArray;
    });
  };

  const isSelectDisabled = (() => {
    if (adminStatus !== 'accepted') return false;

    if (params.data.evaluatorUserId) return true;

    return false;
  })();

  return (
    <div className='w-full '>
      <FormControl variant='outlined' className='w-full '>
        <Select
          labelId='demo-simple-select-helper-label'
          id='demo-simple-select-helper'
          value={adminStatus}
          disabled={isSelectDisabled}
          onChange={(event) => {
            setOpenModal(true);
            setClickedStatus(event.target.value);
          }}
        >
          <MenuItem value='pending'>Pending</MenuItem>
          <MenuItem value='on_hold'>On Hold</MenuItem>
          <MenuItem value='accepted'>
            {adminStatus === 'accepted' ? 'Accepted' : 'Accept'}
          </MenuItem>
        </Select>
      </FormControl>

      <Modal open={openModal}>
        <div className='relative overflow-y-auto max-h-96 top-2 md:top-10 m-auto bg-ab-tertiary bg-white rounded-lg md:px-8 px-3 py-4 z-50 lg:w-1/2 w-11/12 border-solid border border-gray-600 p-50'>
          <div
            className='absolute right-2 top-2 cursor-pointer'
            onClick={() => {
              setOpenModal(false);
            }}
          >
            X
          </div>

          <h2 className='font-bold text-center'>
            {clickedStatus === 'pending'
              ? 'Are you sure?'
              : clickedStatus === 'accepted'
              ? 'Are you sure, you want to accept?'
              : 'Are you sure, you want to put on hold?'}
          </h2>

          <hr />

          {/* on-hold functinality */}
          {clickedStatus === 'on_hold' && (
            <FormControl className='w-full '>
              <div className='text-gray-400 mt-3'>Select Reason :</div>

              {tableProps.notAcceptReasonList.map((option) => (
                <MenuItem
                  key={option}
                  value={option}
                  onClick={() => {
                    handleReasonsMenuClick(option);
                  }}
                >
                  <ListItemIcon>
                    <Checkbox checked={selectedReasons.indexOf(option) > -1} />
                  </ListItemIcon>
                  <ListItemText primary={option} />
                </MenuItem>
              ))}
              <MenuItem
                value='other'
                onClick={() => {
                  setIsOtherReasonsSelected((reason) => !reason);
                }}
              >
                <ListItemIcon>
                  <Checkbox checked={isOtherReasonsSelected} />
                </ListItemIcon>
                <ListItemText primary='Other reasons' />
              </MenuItem>
              <div className='ml-20 px-2 mr-4'>
                <input
                  disabled={!isOtherReasonsSelected}
                  type='text'
                  placeholder='Provide your reason'
                  className='border-b w-full'
                  value={otherReasonText}
                  onChange={(event) => {
                    setOtherReasonText(event.target.value);
                  }}
                />
              </div>
            </FormControl>
          )}

          <div className='flex justify-end items-center mt-4'>
            {showErrorMessage && (
              <span className='text-red-700 text-sm mr-2'>
                Please provide a reason!
              </span>
            )}

            <button
              className='bg-red-c3 p-1 px-2 rounded-md text-white'
              onClick={() => {
                setShowErrorMessage(false);
                const formattedSelectedReasons = getFormattedSelectedReasons();
                if (!formattedSelectedReasons) return;

                tableProps.statusChangeFn(
                  params.data.Students.id,
                  params.data.projectId,
                  clickedStatus,
                  formattedSelectedReasons
                );
                setOpenModal(false);
              }}
            >
              OK
            </button>
          </div>
        </div>
      </Modal>
    </div>
  );
}

export default StatusDropdown;
